import { render, staticRenderFns } from "./internbudgetadd.vue?vue&type=template&id=63be9c88"
import script from "./internbudgetadd.vue?vue&type=script&lang=js"
export * from "./internbudgetadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports